﻿import { useState } from 'react';
import { WizardButtons } from '../../Wizard/WizardButtons';
import { useForm } from 'react-hook-form';
//import { yupResolver } from '@hookform/resolvers/yup';
//import * as Yup from 'yup';
import { Alert, Stack, TextField, Paper, styled } from '@mui/material';
import './beneStyles.css';

const ConfirmCoOwnerCaptureEmail = (props) => {
  const [data, setData] = useState(JSON.parse(window.sessionStorage.getItem('currentBene')));
  const [coOwnerEmail, setCoOwnerEmail] = useState('');

  // const validationSchema = Yup.object().shape({
  //     coOwnerEmail: Yup.string().required('Co-owner email is required').email('Co-owner email is invalid')
  // });
  // const { register, trigger, formState: { errors } } = useForm({
  //     resolver: yupResolver(validationSchema)
  // });

  const {
    register,
    trigger,
    formState: { errors },
  } = useForm();

  const validateForm = () => {
    trigger().then((d) => {
      clickNext(d);
    });
  };

  const clickNext = (val) => {
    if (val) {
      let d = JSON.parse(window.sessionStorage.getItem('currentBene'));
      d.coOwnerEmail = coOwnerEmail;
      window.sessionStorage.setItem('currentBene', JSON.stringify(d));

      props.nextHandler();
    }
  };
  const isBoolean = (ownerEmail) => {
    if (ownerEmail) {
      return true;
    } else {
      return false;
    }
  };
  return (
    <>
      <Stack spacing={2}>
        <Alert severity="info">
          Please confirm Co-Owner Info below before capturing Email Address.
        </Alert>
        <BeneFormItem>
          <span className="formLabel">Co-Owner Name:</span>
          <span className="fullwidth">{data.coOwnerName}</span>
        </BeneFormItem>
        <BeneFormItem>
          <span className="formLabel">Co-Owner Last 4:</span>
          <span className="fullwidth">{data.coOwnerLast4}</span>
        </BeneFormItem>
        <BeneFormItem>
          <span className="formLabel">Email Address:</span>
          <TextField
            {...register('coOwnerEmail')}
            error={isBoolean(errors && errors.coOwnerEmail)}
            helperText={errors && errors.coOwnerEmail && errors.coOwnerEmail.message}
            className="fullwidth"
            value={coOwnerEmail}
            onChange={(e) => {
              setCoOwnerEmail(e.target.value);
            }}
          />
        </BeneFormItem>
      </Stack>
      <WizardButtons {...props} nextHandler={validateForm} />
    </>
  );
};
const decideColor = (theme) => {
  let color = '';
  if (theme.palette.mode === 'dark') {
    color = '#1A2027';
  } else {
    color = '#FFF';
  }
};
const BeneFormItem = styled(Paper)(({ theme }) => ({
  backgroundColor: decideColor(theme),
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'left',
  fontWeight: 'bold',
  display: 'flex',
  alignItems: 'flex-start',
  gap: '.25em',
  color: theme.palette.text.secondary,
}));

export { ConfirmCoOwnerCaptureEmail };
